var voted_users_rtlignore_default = {
  "container": "_0q0CT",
  "webview": "KmZPb",
  "avatar_list": "_4phuK",
  "avatar": "FS-fs",
  "user_avatar": "mLkiH",
  "modal": "vsXO7",
  "voted_users_modal": "fuB-8",
  "overlay": "_1hBGm",
  "user_card": "UbzUU",
  "user_name": "oyZKm",
  "voted_users_modal_header": "pULuG",
  "cta": "sXLk5",
  "close_icon": "pmSDT",
  "title": "rr8M1",
  "member_list_container": "xlsXz",
  "member_list": "n9wP0",
  "loader": "v1Mi3",
  "anonymous_counter": "sCbKA",
  "spinner": "FhlY4",
  "spin": "DavRj"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
